import { Injectable } from '@angular/core';
import { AgentCaseAdministrator } from '../models/api/agent-case-administrator.model';
import { AgentDto, BusinessWriterDto } from '../models/dto';
import { Dictionary } from '../models/interfaces/dictionary';

@Injectable()
export class AgentsBusinessRelationService {
  public linkBusinessWriters(
    agentCaseAdmins: Array<AgentCaseAdministrator>,
    businessWriters: Array<BusinessWriterDto>
  ): Dictionary<string> {
    const linkedBusinessWriters: Dictionary<string> = {};

    for (const businessWriter of agentCaseAdmins) {
      for (const businessWriterAgent of businessWriters) {
        if (businessWriterAgent.AgentID === businessWriter.AgentID) {
          linkedBusinessWriters[businessWriterAgent.AgentID] = businessWriterAgent.FullName;
        }
      }
    }

    return linkedBusinessWriters;
  }

  public linkAgentCaseAdmins(
    agentCaseAdmins: Array<AgentCaseAdministrator>,
    adminCaseAgentsList: Array<AgentDto>
  ): Dictionary<string> {
    const linkedCaseAdmins: Dictionary<string> = {};

    for (const caseAdmin of agentCaseAdmins) {
      for (const agent of adminCaseAgentsList) {
        if (agent.AgentID === caseAdmin.CaseAdministratorID) {
          linkedCaseAdmins[agent.AgentID] = agent.FullName;
        }
      }
    }

    return linkedCaseAdmins;
  }
}
